<template>
  <div class="container report-container">
    <div v-if="loading">
      {{ $t('intro.loading') }}
    </div>
    <div v-else>
      <summary-report
        v-if="receivedResult" class="mb-4"
        :consideration-level="considerationLevel"
        :high-risk-indicator="highRiskIndicator"
        :bdd-indicator="bddIndicator"
        :impulsivity-indicator="impulsivityIndicator"
        :advices="advices"
        :question-answers="reportQuestionAnswers"
        :show-debug-info="showDebugInfo"
      />
      <div v-if="!receivedResult" class="no-info-report">
        {{ $t('end.thankYouNoInfo').replace(/\\n/g, '\n') }}
      </div>
      <app-button
        v-if="receivedResult"
        :state="loading ? 'hide' : 'peak'"
        color="blue"
        position="fixed"
        @click="onClickBottomButton"
      >
        {{ $t('end.buttonFullReport') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import SummaryReport from '@/components/Report/SummaryReport';
import AppButton from '@/components/common/AppButton';
import ReportMixins from '@/components/Report/ReportMixins';
import { addGetParameter } from '../utils/urlUtil';

export default {
  name: 'SummaryReportView',
  components: { SummaryReport, AppButton },
  mixins: [ReportMixins],
  methods: {
    onClickBottomButton() {
      const query = {
        action: 'view',
      };

      if (this.reportSubmissionToken) {
        query.token = this.reportSubmissionToken;
      }

      if (this.reportClientVerificationToken) {
        query.cliniqueVerificationToken = this.reportClientVerificationToken;
      }

      this.$router.push({
        path: `/survey/${this.surveyIdentifier}/report/view`,
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../sass/no-info-report";
</style>
